import React from "react";
import StickyNavbar from "./navbar";
import { Link } from "react-router-dom";
import * as motion from "motion/react-client"

const chapter6 = () => {
    const fadeIn = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
      };
  return (
    <div className="">
      <StickyNavbar />
      <div className="bg-white justify-between  text-black p-4 lg:mt-10 mt-20  sm:p-10 lg:px-20">
        <div className="text-center mb-8">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold">
            Chapter 6: Quality Improvement incorporating Monitoring and
            Evaluation
          </h1>
          <motion.div
            className="text-center mb-8"
            initial="hidden"
            animate="visible"
            variants={fadeIn}
          >


            {/* <motion.div
              className="mt-6 flex items-center justify-center m-auto "
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
            >
              <iframe
                width="65%"
                height="630"
                src="https://res.cloudinary.com/dpz8hsb33/video/upload/v1740857488/Chapter6_research_dissemination_and_community_engagement_fyy0ny.mp4"
                title="Introduction to Research"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="rounded-lg"
              ></iframe>
            </motion.div> */}
          </motion.div>
        </div>
        <div className="flex justify-between mt-10">
          <Link to="/chapter5/sectionThree">
            <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
              Previous
            </button>
          </Link>
          <Link to="/chapter7">
            <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
              Next
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default chapter6;
